import { BadgeTextContainer } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/components/BadgeTextContainer';
import { Text } from '@mantine/core';

interface Props {
	firstName: string;
	lastName: string;
	textColor: string;
}

export const StatusInitialBadge = ({ firstName, lastName, textColor }: Props) => {
	return (
		<BadgeTextContainer align="center" justify="center">
			<Text c={textColor} size="0.75rem">
				{firstName[0]}
				{lastName[0]}
			</Text>
		</BadgeTextContainer>
	);
};
